import { RootState } from '../../store';

export const getRoomSelector = (state: RootState) => state?.roomReducer?.room;
